/* Mo Chara — Gallery Splash v3 */
(function () {
  'use strict';
  var el = document.getElementById('mc-gallery-splash');
  if (!el || sessionStorage.getItem('mc_splash_seen')) { if (el) el.remove(); return; }

  document.body.style.overflow = 'hidden';
  var gone = false;

  function dismiss() {
    if (gone) return; gone = true;
    sessionStorage.setItem('mc_splash_seen', '1');
    document.body.style.overflow = '';
    el.style.transition = 'clip-path 1.1s cubic-bezier(0.76,0,0.24,1)';
    el.style.clipPath = 'inset(0 0 100% 0)';
    setTimeout(function () { if (el.parentNode) el.remove(); }, 1200);
  }

  var btn = document.getElementById('mc-splash-btn');
  if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); dismiss(); });
  el.addEventListener('click', dismiss);
})();
